import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Comercializacion } from './comercializaciones.model';

// LOAD
export const entityComercializacionesLoadRequest = createAction(
  '[ENTITYCOMERCIALIZACIONES] Load Request'
);

export const entityComercializacionesLoadFailure = createAction(
  '[ENTITYCOMERCIALIZACIONES] Load Failure',
  props<{ error: Error }>()
);

export const entityComercializacionesLoadSuccess = createAction(
  '[ENTITYCOMERCIALIZACIONES] Load Success',
  props<{ items: Comercializacion[] }>()
);

// ADD
export const entityComercializacionesAddRequest = createAction(
  '[ENTITYCOMERCIALIZACIONES] Add Request',
  props<{ item: Comercializacion[] }>()
);

export const entityComercializacionesAddFailure = createAction(
  '[ENTITYCOMERCIALIZACIONES] Add Failure',
  props<{ error: Error }>()
);

export const entityComercializacionesAddSuccess = createAction(
  '[ENTITYCOMERCIALIZACIONES] Add Success',
  props<{ item: Comercializacion[] }>()
);
